<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="10">
        <base-material-card color="primary">
          <template v-slot:heading>
            <div
              class="display-2 font-weight-light"
            >{{ id ? $i18n.t("Edit role - ") + role.name : $i18n.t("Create role") }}</div>
          </template>
          <v-form id="form" ref="form" v-model="valid">
            <v-container class="py-0">
              <v-row>
                <v-col cols="4" style="margin-top:17px">
                  <v-text-field
                    :label="$i18n.t('Role Name')"
                    :rules="validationrules.name"
                    required
                    dense
                    v-model="role.name"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>

            <v-container>
              <div v-for="accRight in accessRights" :key="accRight.name">
                <v-card>
                  <v-card-text>
                    <p class="display-1 text--primary">{{accRight.name}}</p>
                    <p>{{accRight.desc}}</p>
                  </v-card-text>

                  <v-row class="row" style="margin-left:60px;margin-right:60px">
                    <v-col cols="12" md="3">
                      <v-checkbox
                        v-model="accRight.selected"
                        :label="`View`"
                        style="margin-right:60px"
                      ></v-checkbox>
                    </v-col>

                    <v-col
                      cols="12"
                      md="3"
                      v-for="right in accRight.accessRights"
                      :key="right.name"
                    >
                      <v-checkbox
                        v-model="right.selected"
                        :label="`${right.name}`"
                        style="margin-right:60px"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-card>
              </div>
            </v-container>
            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  valid = true;
  role = {
    _id: null,
    rights: [],
  };
  accessRights = [];
  componentKey = 0;
  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
  };
  id = null;

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      let t = "";
      for (let i = 0; i < this.accessRights.length; i++) {
        if (this.accessRights[i]["selected"]) {
          t = t + this.accessRights[i].code + ",";
        }
        if (this.accessRights[i].accessRights != null) {
          for (let j = 0; j < this.accessRights[i].accessRights.length; j++) {
            if (this.accessRights[i].accessRights[j].selected) {
              t = t + this.accessRights[i].accessRights[j].value + ",";
            }
          }
        }
      }
      // console.log(this.role);
      this.role.rights = t;
      common.setLoading(true);
      this.role = await doPost("/api/role/save", this.role);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.role = await doGet("/api/role/" + id + "/detail");
      this.id = this.role._id;
      // console.log(this.role);
      this.postDetailFetch();
    } catch (e) {
      common.setError(e.message);
    }
  }

  async postDetailFetch() {
    try {
      if (this.role && this.role.rights) {
        const arr = this.role.rights.split(",");
        Outer: for (let k = 0; k < arr.length; k++) {
          for (let i = 0; i < this.accessRights.length; i++) {
            if (arr[k] == this.accessRights[i].code) {
              this.accessRights[i].selected = true;
              continue Outer;
            }
            if (this.accessRights[i].accessRights != null) {
              for (
                let j = 0;
                j < this.accessRights[i].accessRights.length;
                j++
              ) {
                if (arr[k] == this.accessRights[i].accessRights[j].value) {
                  this.accessRights[i].accessRights[j].selected = true;
                  continue Outer;
                }
              }
            }
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
    // console.log(this.accessRights);
  }

  async accessRght() {
    try {
      this.accessRights = await doGet("/api/access/right/map");
      // console.log(this.accessRights);
      for (let i = 0; i < this.accessRights.length; i++) {
        this.accessRights[i].selected = false;
        if (this.accessRights[i].accessRights != null) {
          for (let j = 0; j < this.accessRights[i].accessRights.length; j++) {
            this.accessRights[i].accessRights[j].selected = false;
          }
        }
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    await this.accessRght();
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }
}
</script>

<style scoped>
.week-button {
  padding: 5px 4px;
  height: 30px;
  width: 30px;
  justify-content: center;
}
</style>
